import { cookie } from '@pmi/pmi-iqos-shared-react'

export default class IqosphereEvent {
  constructor(api) {
    this.api = api
  }

  getEventsDigitalPasses = async ids => {
    const res = await this.api.get(`/iqosphere/events?ids=${ids}`, {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      useProxy: true,
      withCredentials: true,
      mock: this.api.getMock('getEventsDigitalPasses')
    })
    return res
  }

  assignDigitalPasses = async data => {
    const res = await this.api.post('/iqosphere/events/digitalpasses/assign', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      useProxy: true,
      withCredentials: true,
      mock: this.api.getMock('AssignDigitalPasses'),
      data
    })
    return res
  }

  burnDigitalPasses = async data => {
    const res = await this.api.post('/iqosphere/digitalpasses/burn', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      useProxy: true,
      withCredentials: true,
      mock: this.api.getMock('BurnDigitalPasses'),
      data
    })
    return res
  }
}
